import { BulkFunctionCallResult as _BulkFunctionCallResult } from "./useBulkSpaceFunction";
export { default } from "./useBulkSpaceFunction";
export type BulkFunctionCallResult = _BulkFunctionCallResult;
